module.exports = "<header-bar></header-bar>\n\n<main>\n\t<router-outlet></router-outlet>\n</main>\n\n<footer></footer>\n\n<snack-bar></snack-bar>"


//////////////////
// WEBPACK FOOTER
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/app/app.html
// module id = ../../../../../src/app/components/app/app.html
// module chunks = 1